(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["dab-product-recs"] && !Shopify.designMode) return;
  try {
    
  const loadDabProductRecommendations = async () => {
    const sections = document.querySelectorAll('.dab-product-recs product-recommendations:not([data-dab-loaded])');

    sections.forEach(async (section) => {
      section.setAttribute('data-dab-loaded', 'true');

      if (section.querySelector('.dab-product-recs__grid')) return;

      const requestUrl = `${section.dataset.url}&section_id=${section.dataset.sectionId}&product_id=${section.dataset.productId}`;

      try {
        const response = await fetch(requestUrl);
        if (!response.ok) return;

        const html = await response.text();
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const recommendations = parsed.querySelector('.dab-product-recs product-recommendations');

        if (recommendations?.innerHTML.trim()) {
          section.innerHTML = recommendations.innerHTML;
        }
      } catch (error) {
        section.removeAttribute('data-dab-loaded');
      }
    });
  };

  loadDabProductRecommendations();
  document.addEventListener('shopify:section:load', loadDabProductRecommendations);

  document.addEventListener('click', (event) => {
    const button = event.target.closest('.dab-product-rec-card__heart');
    if (!button) return;
    button.setAttribute('aria-pressed', button.getAttribute('aria-pressed') === 'true' ? 'false' : 'true');
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dab-product-style"] && !Shopify.designMode) return;
  try {
    
  const initializeDabProductGallery = (scope = document) => {
    scope.querySelectorAll('media-gallery').forEach((gallery) => {
      if (gallery.dataset.dabSmoothGallery === 'true') return;

      gallery.addEventListener('click', (event) => {
        const thumbnail = event.target.closest('.thumbnail');
        if (!thumbnail) return;

        gallery.classList.remove('dab-media-switching');
        requestAnimationFrame(() => gallery.classList.add('dab-media-switching'));
        window.setTimeout(() => gallery.classList.remove('dab-media-switching'), 260);
        thumbnail.scrollIntoView({ behavior: 'smooth', block: 'nearest', inline: 'center' });
      });

      gallery.dataset.dabSmoothGallery = 'true';
    });
  };

  initializeDabProductGallery();
  document.addEventListener('shopify:section:load', (event) => initializeDabProductGallery(event.target));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dab-shop-product-grid"] && !Shopify.designMode) return;
  try {
    
  const initDabShopGrid = (scope) => {
    if (!scope || scope.dataset.initialized === 'true') return;
    scope.dataset.initialized = 'true';
    const grid = scope.querySelector('[data-product-grid]');
    const cards = Array.from(scope.querySelectorAll('[data-product-card]'));
    const search = scope.querySelector('[data-shop-search]');
    const sale = scope.querySelector('[data-sale-filter]');
    const price = scope.querySelector('[data-price-filter]');
    const priceOutput = scope.querySelector('[data-price-output]');
    const count = scope.querySelector('[data-result-count]');
    const loadMore = scope.querySelector('[data-load-more]');
    const empty = scope.querySelector('[data-empty-state]');
    const initialLimit = Number(scope.dataset.initialLimit || 12);
    let visibleLimit = initialLimit;

    const applyFilters = () => {
      const term = search.value.trim().toLowerCase();
      const saleOnly = sale.checked;
      const max = Number(price.value);
      const matches = cards.filter((card) => {
        const matchesSearch = !term || card.dataset.search.includes(term);
        const matchesSale = !saleOnly || card.dataset.sale === 'true';
        const matchesPrice = Number(card.dataset.price) <= max;
        return matchesSearch && matchesSale && matchesPrice;
      });
      cards.forEach((card) => { card.hidden = true; });
      matches.slice(0, visibleLimit).forEach((card) => { card.hidden = false; });
      count.textContent = String(matches.length);
      empty.hidden = matches.length !== 0;
      loadMore.hidden = matches.length <= visibleLimit;
    };

    [search, sale, price].forEach((control) => {
      control.addEventListener('input', () => {
        visibleLimit = initialLimit;
        if (control === price) priceOutput.textContent = price.value;
        applyFilters();
      });
    });

    loadMore.addEventListener('click', () => {
      visibleLimit += initialLimit;
      applyFilters();
    });

    scope.querySelector('[data-sort-select]').addEventListener('change', (event) => {
      const url = new URL(window.location.href);
      url.searchParams.set('sort_by', event.target.value);
      window.location.href = url.toString();
    });

    const gridButton = scope.querySelector('[data-grid-view]');
    const listButton = scope.querySelector('[data-list-view]');
    gridButton.addEventListener('click', () => {
      grid.classList.remove('is-list');
      gridButton.classList.add('is-active');
      listButton.classList.remove('is-active');
      gridButton.setAttribute('aria-pressed', 'true');
      listButton.setAttribute('aria-pressed', 'false');
    });
    listButton.addEventListener('click', () => {
      grid.classList.add('is-list');
      listButton.classList.add('is-active');
      gridButton.classList.remove('is-active');
      listButton.setAttribute('aria-pressed', 'true');
      gridButton.setAttribute('aria-pressed', 'false');
    });

    scope.querySelectorAll('[data-wishlist]').forEach((button) => {
      const key = `dab-wishlist-${button.dataset.wishlist}`;
      try { button.setAttribute('aria-pressed', localStorage.getItem(key) === 'true' ? 'true' : 'false'); } catch (error) {}
      button.addEventListener('click', () => {
        const next = button.getAttribute('aria-pressed') !== 'true';
        button.setAttribute('aria-pressed', String(next));
        try { localStorage.setItem(key, String(next)); } catch (error) {}
      });
    });

    scope.querySelectorAll('[data-product-form]').forEach((form) => {
      form.addEventListener('submit', async (event) => {
        event.preventDefault();
        const button = form.querySelector('button');
        const label = form.querySelector('[data-button-label]');
        const original = label.textContent;
        button.disabled = true;
        try {
          const response = await fetch(`${window.Shopify.routes.root}cart/add.js`, { method: 'POST', headers: { Accept: 'application/json' }, body: new FormData(form) });
          if (!response.ok) throw new Error('Unable to add product');
          label.textContent = 'Added';
          document.dispatchEvent(new CustomEvent('cart:refresh'));
        } catch (error) {
          label.textContent = 'Try again';
        }
        window.setTimeout(() => { label.textContent = original; button.disabled = false; }, 1600);
      });
    });

    applyFilters();
  };

  document.querySelectorAll('.dab-shop-grid').forEach(initDabShopGrid);
  document.addEventListener('shopify:section:load', (event) => initDabShopGrid(event.target.querySelector('.dab-shop-grid')));

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
